import React from 'react';

import { onboardingTestIDs } from '@constants';

import { SubscriberWelcomeBackPageContent } from './components/SubscriberWelcomeBackPageContent';

import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';

export const SubscriberWelcomeBackPage = () => (
  <TWCPage
    childIds={[onboardingTestIDs.subscriberWelcomeBack.continueButton]}
    firstFocus={onboardingTestIDs.subscriberWelcomeBack.continueButton}
    hasBackground={false}
    pageID={onboardingTestIDs.pages.subscriberWelcomeBackPage}
  >
    <SubscriberWelcomeBackPageContent.API />
  </TWCPage>
);
